import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproaches } from './components/FailedApproaches';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferCTA } from './components/OfferCTA';
import { BotanicalDivider } from './components/BotanicalDivider';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-cream overflow-hidden selection:bg-sage/20 selection:text-brown-heading" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <BotanicalDivider data-id="element-4" />
      <FailedApproaches data-id="element-5" />
      <UniqueMechanism data-id="element-6" />
      <BotanicalDivider data-id="element-7" />
      <WhatYouGet data-id="element-8" />
      <WhoIsFor data-id="element-9" />
      <BotanicalDivider data-id="element-10" />
      <HowItWorks data-id="element-11" />
      <ProofSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <OfferCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </main>;
}